import { create } from "zustand";
import axios from "axios";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";

const TicketsStore = create((set) => ({
  data: [],
  loading: false,
  error: null,

  getData: async (query) => {
    set({ loading: true, error: null });
    try {
      console.log(query);
      const { data } = await axiosInstance.get(
        `/api/chiqim-official/ammafos-kaliy?${query}`
        // `/api/chiqim-official/ammafos-kaliy?product=Аммофос&offset=0&limit=50`
      );
      console.log(data);
      set({ data: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  updateItem: async (id, updatedFields) => {
    try {
      const response = await axiosInstance.put(
        `/api/customers/${id}`,
        updatedFields
      );
      set((state) => ({
        data: state.data.map((item) =>
          item.id === id ? { ...item, ...response.data } : item
        ),
      }));
    } catch (error) {
      set({ error: error.message });
    }
  },
  // Search customers from the database
  searchCustomers: async (query) => {
    set({ loading: true, error: null });
    try {
      const { data } = await axiosInstance.get(
        `/api/customers/search?search=${query}`
      );
      set({ data: data.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export { TicketsStore };
